/* eslint-disable @typescript-eslint/strict-boolean-expressions */
import { Suspense } from "react";
import { useCookieConsent } from "./shared/custom-hooks/useCookieConsent";
import { Layout } from "syngenta-digital-cropwise-react-ui-kit";
import "./index.less";
import { AppContext } from "./lib/appContext/AppContext";
import { AppRoutes } from "./lib/appRoutes";
import { ErrorBoundary } from "./shared/components/ErrorBoundary";
import { Loader } from "./shared/components/Loader";
import { AppBarPlatform } from "./shared/layout/AppBarPlatform";
import { SidebarMenu } from "./shared/layout/Sidebar";
import { ThemeProvider } from "./shared/layout/ThemeProvider";
import { LDFlagsProvider } from "./context/LDFlagsContext";

const { Content } = Layout;

function App(): JSX.Element | null {
  useCookieConsent();
  return (
    <LDFlagsProvider>
      <ErrorBoundary>
        <ThemeProvider>
          <AppContext>
            <div className="app-root">
              <Suspense
                fallback={<Loader mask={true} message="Loading AppBar..." />}
              >
                <AppBarPlatform />
              </Suspense>
              <Layout className="cw-page-container">
                <Suspense
                  fallback={<Loader mask={true} message="Loading..." />}
                >
                  <SidebarMenu />
                  <Layout className="main-layout">
                    <Content className="main-content">
                      <AppRoutes />
                    </Content>
                  </Layout>
                </Suspense>
              </Layout>
            </div>
          </AppContext>
        </ThemeProvider>
      </ErrorBoundary>
    </LDFlagsProvider>
  );
}

export default App;
